import Vue from 'vue';

export const shopLayout = Vue.observable({
  dockHeight: 0,
  dockTop: null as number | null,
});

export function elementFromRef(value: unknown): HTMLElement | null {
  const ref = Array.isArray(value) ? value[0] : value;
  const element = ref instanceof Vue ? ref.$el : ref;
  return element instanceof HTMLElement ? element : null;
}
